const CryptoJS = require('crypto-js');

// export const API_URL = 'http://localhost:8080/wsw_web_war';

// export const API_URL_NO_PORT = 'http://localhost:8080';
// export const API_URL = 'http://localhost:8080/wsw_web_war';
// export const IMG_API_URL = 'http://localhost:8080/wsw_web_war';

export const API_URL_NO_PORT = 'https://www.btc-kxtj.com';
export const API_URL = 'https://www.btc-kxtj.com:8089/wsw';
export const IMG_API_URL = 'https://www.btc-kxtj.com:8089/wsw';


export const LOGIN_URL = '/user/login';
export const BECOME_VIP_URL = '/vip-membership';

export const categories = [
  "新手入门", "大神特辑", "基本面分析","交易心理学", "庄家手法","仓位管理",
  "止盈止损", "小资金操作","短线技术","趋势交易", "交易策略","技术指标"
];

export const VIP_BLOG_NAME = '如何成为VIP';

export const strategyType = ['套利', '现货', '合约', '稳健', '进阶', '高收益'];


